module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Pink-f9a9a0beba21dad371b4c59038529d0c.png";